
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-event",
      function () {
        return require("private-next-pages/create-event/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-event"])
      });
    }
  